export const MF_SECURITY_DATA = {
  urlSuccess: '/home/ccv/successful-regimen-modification',
  urlGoBack: '/home/ccv/regime-modify',
  titleText: 'Elige una clave para cambiar de Régimen Tributario',
  subtitleText:
    'Por seguridad selecciona una de las claves para validar tu trámite',
};
